import { httpClient } from '../services/httpClient';

export const businessEmailCheck = async (email: string, signal?: AbortSignal) => {
  try {
    const response = await httpClient.post(
      '/lpapi/form/EmailDomainCheck',
      { email: email },
      { validateStatus: () => true, signal }
    );

    if (response.data?.isGeneric === '0') {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
